var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImporticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(-334 -429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(69.607 1.607)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(264.393 427.393)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_0b0bb8d0184d311551605e84fd2400a2",
    "data-name": "0b0bb8d0184d311551605e84fd2400a2",
    d: "M12.414,15l1.293,1.293a1,1,0,0,1-1.414,1.414l-3-3a1,1,0,0,1,0-1.414l3-3a1,1,0,0,1,1.414,1.414L12.414,13H18a2,2,0,0,1,2,2v4a3,3,0,0,1-3,3H5a1,1,0,0,1-1-1V5A3,3,0,0,1,7,2h7.459a3,3,0,0,1,2.457,1.28l2.542,3.63A3,3,0,0,1,20,8.63V10a1,1,0,0,1-2,0V8.63a1,1,0,0,0-.181-.573l-2.541-3.63A1,1,0,0,0,14.459,4H7A1,1,0,0,0,6,5V20H17a1,1,0,0,0,1-1V15Z",
    transform: "translate(346 441)",
    fill: "#141414",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImporticon);
export default __webpack_public_path__ + "static/media/importicon.71047b58e69014b7ae1af125ad5f4973.svg";
export { ForwardRef as ReactComponent };